import "./collaboration.scss";
import { motion } from "framer-motion";
import desktopImage from "../../../Assets/images/collabimage.svg";
import monitorVideo from "../../../Assets/videos/map3.mp4";

const Collaboration = () => {
  return (
    <section className="collaboration container">
      <div className="row align-items-center position-relative">
        <motion.div
          className="col-md-6 text-center text-md-start mb-4 mb-md-0 position-relative"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: true }}
        >
          <img
            src={desktopImage}
            alt="Creative Design Showcase"
            className="img-fluid inquiry-img"
          />

          <div className="monitor-video-wrapper">
            <video
              className="monitor-video"
              src={monitorVideo}
              autoPlay
              loop
              muted
              playsInline
            />
          </div>
        </motion.div>

        <div className="col-md-6  collaboration-text">
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h2>Our Network</h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.99, ease: "easeOut", delay: 0.3 }}
            viewport={{ once: true }}
          >
            <h4>Collaboration for Engineering Excellence</h4>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.99, ease: "easeOut", delay: 0.4 }}
            viewport={{ once: true }}
          >
            <p className="mb-4">
              We have collaborated with MC2 Design LLC for architectural
              services and DEKAT Engineering LLC for structural engineering—both
              based in Colorado, USA.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.99, ease: "easeOut", delay: 0.4 }}
            viewport={{ once: true }}
          >
            <p>
              In 2025, we further expanded our global network by partnering with
              DR Structural Engineering & Consulting LLC and ​​RNG Engineering
              also based in Colorado. This collaboration marks a significant
              step in strengthening our technical capabilities and deepening our
              impact in the engineering sector.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Collaboration;
